import type { Table } from "common/data/table";
import type { FrameFloorAssemblyEntity } from "./frameFloorAssemblyTypes";
import type { SlabFloorAssemblyEntity } from "./slabFloorAssemblyTypes";

export type FloorAssemblyEntity = FrameFloorAssemblyEntity | SlabFloorAssemblyEntity;

export function getFloorAssemblyEntity(
  floorAssemblyId: string,
  frameFloorAssemblies: Table<FrameFloorAssemblyEntity>,
  slabFloorAssemblies: Table<SlabFloorAssemblyEntity>,
): FloorAssemblyEntity | undefined {
  const frameFloorAssembly = frameFloorAssemblies[floorAssemblyId];
  if (frameFloorAssembly) {
    return frameFloorAssembly;
  }
  const slabFloorAssembly = slabFloorAssemblies[floorAssemblyId];
  if (slabFloorAssembly) {
    return slabFloorAssembly;
  }
  return undefined;
}

export function retrieveStructuralAndSubFloorComponentIds(floorAssemblyEntity: FloorAssemblyEntity): {
  structureId: string;
  subFloorId: string;
} {
  if (floorAssemblyEntity.entityType === "FRAME_FLOOR_ASSEMBLY") {
    return {
      structureId: floorAssemblyEntity.joistComponentId,
      subFloorId: floorAssemblyEntity.subFloorComponentId,
    };
  } else {
    return {
      structureId: floorAssemblyEntity.slabComponentId,
      subFloorId: floorAssemblyEntity.subFloorComponentId,
    };
  }
}
